export default "__VITE_ASSET__C63B$rGE__"